import { render, staticRenderFns } from "./page-logo.vue?vue&type=template&id=62f57c68&scoped=true"
import script from "./page-logo.ts?vue&type=script&lang=ts&external"
export * from "./page-logo.ts?vue&type=script&lang=ts&external"
import style0 from "./page-logo.scss?vue&type=style&index=0&id=62f57c68&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f57c68",
  null
  
)

export default component.exports